module.exports = __webpack_public_path__ + "img/introFour.b6bba173.png";